
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 20.62c-2.43-2.142-4.217-4.1-5.406-5.883C5.323 12.831 4.8 11.224 4.8 9.868 4.8 5.76 8.02 2.8 12 2.8s7.2 2.96 7.2 7.068c0 1.356-.523 2.963-1.794 4.87-1.189 1.781-2.976 3.74-5.406 5.882zm-.658 1.814c.378.325.938.325 1.316 0C18.188 17.675 21 13.52 21 9.868 21 4.696 16.903 1 12 1S3 4.696 3 9.868c0 3.652 2.811 7.807 8.342 12.566z","fill":"#999"}}),_c('path',{attrs:{"d":"M12 12a2 2 0 100-4 2 2 0 000 4z","fill":"#999"}})])
          )
        }
      }
    